export default "__VITE_ASSET__BvjAu6_X__"